export default "__VITE_ASSET__KydA3h4n__"